// extracted by mini-css-extract-plugin
export default {"tooltip":"zP-z","arrow":"AP-z"};